module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-76.384d7543.svg";